import { NON_FILTERABLE_CONTRACT_ROLLUP_FIELD_KEYS } from "./contractRollupFields";

/**
 * Every filter key a saved view can still carry that no picker offers any more.
 *
 * A key withheld from the picker but left in a persisted view keeps filtering
 * with no chip to remove it: the toolbar renders chips only for keys it can
 * resolve to a filter option, while the filter badge counts the raw `filters`
 * object, so the count and the visible chips disagree and an untouched view
 * shows no "Clear filters" button to recover with.
 *
 * Withdrawal happens for unrelated reasons — a field that was never meant to be
 * filterable, or one replaced by a filter on a different key — so the reasons
 * stay documented in their own modules and only the resulting key set is pooled
 * here, giving the deserializer one place to look and one place to grow.
 *
 * Keys compare camelCased, matching what the entity-fields endpoint emits.
 */
export const WITHDRAWN_FILTER_KEYS = new Set<string>([
  ...NON_FILTERABLE_CONTRACT_ROLLUP_FIELD_KEYS,
  // Replaced by the onboardingStageName picker, which filters the derived value
  // the contracts column displays rather than this raw FK id.
  "onboardingStageId"
]);
